import { MaritalRegime, MaritalStatus } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredEnum } from '@/utils/zodUtils';

export const FamiliarSituationFormSchema = (t: GetTextIdTranslationType) =>
  z
    .object({
      maritalStatus: requiredEnum(MaritalStatus, t),
      maritalRegime: z.nativeEnum(MaritalRegime).optional().nullable(),
      childSupportNumber: z
        .number({ message: t('REQUIRED_FIELD') })
        .min(0, { message: t('EQUAL_OR_LARGER_THAN').replace('$v1', '0') }),
    })
    .refine((data) => !(data.maritalStatus === MaritalStatus.MARRIED && !data.maritalRegime), {
      message: t('REQUIRED_FIELD'),
      path: ['maritalRegime'],
    });

export type FamiliarSituationFormType = z.infer<ReturnType<typeof FamiliarSituationFormSchema>>;
